import * as React from 'react';
import Moment from "moment";
import AuthorizationLevelControl, { ILevelPermission } from './AuthorizationLevelControl';
import lang from '../Relations/RelationsLang';
import { IConfig } from './Models';
import { DatesFieldFormRow, LabelFormRow } from '../Relations/FormsControls';
import { OptionType } from '../ResourcesAutocompleteMI';
import { SubRowHeader } from '../Relations/Components';


interface IAuthorizationLevelInputControlResult {
	from: Moment.Moment,
	to: Moment.Moment,
	levels: ILevelPermission[],
}

interface IProps {
	resourceName,
	permissionLevels: ILevelPermission[],

	config: IConfig,
	selectedEmployees: OptionType[],
}

interface IState {
	dateError: string,
	selectedFrom: Moment.Moment,
	selectedTo: Moment.Moment,

	selectedLevels: ILevelPermission[],
	permissionLevelError: string,
}

export class AuthorizationLevelInputControl extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			dateError: "",
			selectedFrom: null,
			selectedTo: null,

			selectedLevels: [],
			permissionLevelError: "",
		};
	}

	isValidAdd() {
		let fieldsConfig = this.props.config.fields;
		let from = this.state.selectedFrom;
		if (!from) {
			from = Moment({ h: 0, m: 0, s: 0, ms: 0 });
		}

		let to = this.state.selectedTo;

		let result = true;
		let state = {
			dateError: "",
			permissionLevelError: "",
		};
		
		if (fieldsConfig.level.required) {
			if (this.state.selectedLevels.length == 0) {

				let label = lang.getDefaultByPrefix(fieldsConfig.level, "label", "authorizationLevel");

				state.permissionLevelError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (to && from > to) {
			state.dateError = "control.relation.fromToErrorMessage";
			result = false;
		}

		if (fieldsConfig.dateTo.required) {
			if (!to) {
				let label = lang.getDefaultByPrefix(fieldsConfig.dateTo, "label", "to");
				state.dateError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		this.setState(state);
		return result;
	}

	getValues(): IAuthorizationLevelInputControlResult {
		let from = this.state.selectedFrom;
		if (!from) {
			from = Moment();
		}

		let to = this.state.selectedTo;
		return {
			from: from,
			to: to,
			levels: this.state.selectedLevels,
		}
	}

	handleSelectedFrom(date: Moment.Moment) {
		this.setState({ selectedFrom: date })
	}

	handleSelectedTo(date: Moment.Moment) {
		this.setState({ selectedTo: date })
	}

	render() {

		let fields = this.props.config.fields;

		return <div className="sub-input-row">
			<dl className="form-field">
				<dt>
					<label>{lang.resource()}:</label>
				</dt>
				<dd>
					<SubRowHeader>{this.props.resourceName}</SubRowHeader>
					{this.state.permissionLevelError && <p className="text-danger">{this.state.permissionLevelError}</p>}
					{this.renderLevel()}

					<DatesFieldFormRow
						editRow={false}
						errorText={this.state.dateError}
						dateFromConfig={fields.dateFrom}
						dateToConfig={fields.dateTo}
						from={this.state.selectedFrom}
						to={this.state.selectedTo}
						onChange={(from, to) => this.setState({ selectedFrom: from, selectedTo: to })}
					/>
				</dd>
			</dl>
		</div>
	}

	renderLevel() {
		let fields = this.props.config.fields;
		if (fields.level.hidden)
			return null;

		return <>
			<div className="text-field">
				<LabelFormRow
					config={fields.level}
					name="level"
				/>

				<AuthorizationLevelControl
					value={this.state.selectedLevels}
					onChange={(data) => this.setState({ selectedLevels: data })}
					options={this.props.permissionLevels}
				/>
			</div>
		</>
	}
}